module.exports = __webpack_public_path__ + "static/media/27.424a49a8.png";